import React from 'react'
import UpdateDesignationForm from '../../../component/form/master/designation/UpdateDesignationForm'

export default function UpdateDesigantion() {
    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <UpdateDesignationForm />
                    </div>
                </div>
            </div>
        </>
    )
}
